<svg
  (mouseenter)="mouseEnter()"
  (mouseleave)="mouseLeave()"
  [attr.height]="height"
  [attr.width]="width"
  [class.cursor-pointer]="isButton"
  fill="none"
  viewBox="0 0 12 16"
>
  <path
    [attr.fill]="color"
    d="M4.66667 11.3333C4.66667 11.7013 4.36867 12 4 12C3.63133 12 3.33333 11.7013 3.33333 11.3333C3.33333 10.9653 3.63133 10.6667 4 10.6667C4.36867 10.6667 4.66667 10.9653 4.66667 11.3333ZM6.66667 11.3333C6.66667 11.7013 6.36867 12 6 12C5.63133 12 5.33333 11.7013 5.33333 11.3333C5.33333 10.9653 5.63133 10.6667 6 10.6667C6.36867 10.6667 6.66667 10.9653 6.66667 11.3333ZM8.66667 11.3333C8.66667 11.7013 8.36867 12 8 12C7.63133 12 7.33333 11.7013 7.33333 11.3333C7.33333 10.9653 7.63133 10.6667 8 10.6667C8.36867 10.6667 8.66667 10.9653 8.66667 11.3333ZM10 6.66667V4C10 1.79133 8.20867 0 6 0C3.79133 0 2 1.79133 2 4V6.66667H0V16H12V6.66667H10ZM3.33333 4C3.33333 2.52933 4.53 1.33333 6 1.33333C7.47 1.33333 8.66667 2.52933 8.66667 4V6.66667H3.33333V4ZM10.6667 14.6667H1.33333V8H10.6667V14.6667Z"
  />
</svg>
